/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/prop-types */
import { useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages";
import SignInPage from "@/pages/sign-in";
import SignUpPage from "@/pages/sign-up";
import TradePage from "@/pages/trade";
import Profile from "@/pages/profile";
import Verification from "@/pages/profile/verification";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import MUITheme from "./MUITheme";
import CssBaseline from "@mui/material/CssBaseline";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { inject, observer } from "mobx-react";
import Store from "@/store";
import { AppProps } from "@/@types/App";
import CreatePost from "@/pages/trade/create-post";
import MyPostsPage from "@/pages/trade/my-posts";
import EmailVerifyPage from "@/pages/Login/EmailVerify";
import PhoneNumberVerifyPage from "@/pages/profile/PhoneNumberVerify";
import { Web3Modal } from "@web3modal/react";
import { useAccount, useWalletClient } from "wagmi";
import { projectId, ethereumClient, wagmiClient, chains } from "@/web3modal";
import AccessGuard from "@/components/AccessGuard";
import ChatPage from "@/pages/trade/chat";
import PaymentPage from "@/pages/profile/Payments";
import PaymentCreateEditPage from "@/pages/profile/Payments/CreateEdit";
import MyOrderPage from "./pages/trade/my-orders";
import MyWallet from "./pages/MyWallet";
import CircularProgress from "@mui/material/CircularProgress";
import AppealPage from "./pages/Appeal";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { CloseRounded } from "@mui/icons-material";
import { UI_ACTION_STATE } from "./store/common";
import { autorun } from "mobx";
import PolicyPage from "./pages/Policy/indext";
import TermsPage from "./pages/Terms";

const IS_TESTNET = process.env.REACT_APP_IS_TESTNET === "true";

const App = inject(
  Store.type.userStore,
  Store.type.tradingStore,
  Store.type.commonStore,
  Store.type.contractStore,
  Store.type.myWalletStore,
  Store.type.orderStore,
  Store.type.chatOrderStore,
  Store.type.chatAppealStore,
)(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observer((props: any) => {
    if (!projectId) {
      throw new Error("Could not find project id in app component");
    }

    const theme = useTheme();
    const {
      userStore,
      tradingStore,
      commonStore,
      orderStore,
      chatOrderStore,
      chatAppealStore,
      myWalletStore,
      contractStore,
    } = props as AppProps;

    // const wsLink = props.wsLink;

    const { address } = useAccount();
    const { data: signer } = useWalletClient({
      chainId: IS_TESTNET ? 373737 : 8794598,
    });
    useEffect(() => {
      if (userStore.isLogin) {
        commonStore.fetchAssets();
        commonStore.fetchPaymentMethods();
        commonStore.fetchAmlLevels();
        commonStore.fetchDocuments();
        // try {
        //   wsLink.subscriptionClient.client.send(
        //     JSON.stringify({
        //       type: "connection_init",
        //       payload: {
        //         headers: {
        //           authorization: `Bearer ${userStore.accessToken()}`,
        //         },
        //       },
        //     }),
        //   );
        // } catch (error) {
        //   try {
        //     setTimeout(() => {
        //       wsLink.subscriptionClient.client.send(
        //         JSON.stringify({
        //           type: "connection_init",
        //           payload: {
        //             headers: {
        //               authorization: `Bearer ${userStore.accessToken()}`,
        //             },
        //           },
        //         }),
        //       );
        //     }, 10000);
        //   } catch (error) {
        //     console.error(error);
        //   }
        // }
      } else {
        // try {
        //   wsLink.subscriptionClient.client.send(
        //     JSON.stringify({
        //       type: "connection_init",
        //       payload: {},
        //     }),
        //   );
        // } catch (error) {
        //   console.error(error);
        // }
      }
    }, [userStore.isLogin]);
    useEffect(() => {
      if (address) {
        if (wagmiClient.connector?.switchChain) {
          wagmiClient.connector?.switchChain(IS_TESTNET ? 373737 : 8794598);
        }
        if (signer) {
          // contractStore.setSigner(signer);
          contractStore.setAddress(address);
        }
      }
    }, [address, signer]);
    useEffect(() => {
      if (userStore.isLogin && signer && address) {
        myWalletStore.setAssets(commonStore.assets);
        for (let i = 0; i < commonStore.assets.length; i++) {
          const asset = commonStore.assets[i];
          myWalletStore.fetchBalancesOfTokens(asset.address).catch((error) => {
            console.error("Error my assets:", error);
          });
        }
      }
    }, [signer, userStore.isLogin, address, commonStore.assets]);
    useEffect(() => {
      if (
        address &&
        userStore.wallet_address &&
        userStore.wallet_address !== address
      ) {
        enqueueSnackbar(
          `Please connect the same wallet as your account setting (${
            userStore.wallet_address &&
            `${userStore.wallet_address.substring(
              0,
              6,
            )}...${userStore.wallet_address.substring(
              userStore.wallet_address.length - 4,
            )}`
          }) to proceed any transactions.`,
          {
            variant: "warning",
            autoHideDuration: 10000,
            action: (key) => (
              <IconButton
                size="small"
                onClick={() => {
                  closeSnackbar(key);
                }}
              >
                <CloseRounded fontSize="small" sx={{ color: "#fff" }} />
              </IconButton>
            ),
          },
        );
      }
    }, [address, userStore.isLogin]);

    // for notifications
    useEffect(() => {
      let unsubscribeMyOrders: (() => void) | null = null;
      let unsubscribeMyOrderMessages: (() => void) | null = null;
      let unsubscribeMyAppealMessages: (() => void) | null = null;
      const disposeAutorun = autorun(async () => {
        const userId = userStore.userId;
        if (userId) {
          if (!unsubscribeMyOrders) {
            unsubscribeMyOrders = await orderStore.subscribeToMyOrders(userId);
          }
          if (!unsubscribeMyOrderMessages) {
            unsubscribeMyOrderMessages =
              await chatOrderStore.subscribeToMyOrderMessages(userId);
          }
          if (!unsubscribeMyAppealMessages) {
            unsubscribeMyAppealMessages =
              await chatAppealStore.subscribeToMyAppealMessages(userId);
          }
        }
      });

      return () => {
        disposeAutorun();
        if (unsubscribeMyOrders) {
          unsubscribeMyOrders();
          unsubscribeMyOrders = null;
        }
        if (unsubscribeMyOrderMessages) {
          unsubscribeMyOrderMessages();
          unsubscribeMyOrderMessages = null;
        }
        if (unsubscribeMyAppealMessages) {
          unsubscribeMyAppealMessages();
          unsubscribeMyAppealMessages = null;
        }
      };
    }, [userStore]);

    return (
      <MUIThemeProvider theme={MUITheme}>
        <CssBaseline />
        <Router basename="/">
          <Stack direction="column" height="fit-content" minHeight="100vh">
            <Navbar userStore={userStore} commonStore={commonStore} />
            <Box component="main" flexGrow="1">
              <Routes>
                <Route
                  path="/"
                  element={
                    <HomePage
                      tradingStore={tradingStore}
                      commonStore={commonStore}
                    />
                  }
                />
                <Route
                  path="/sign-in"
                  element={
                    <SignInPage
                      userStore={userStore}
                      commonStore={commonStore}
                    />
                  }
                />
                <Route
                  path="/sign-up"
                  element={<SignUpPage userStore={userStore} />}
                />
                <Route
                  path="/trade"
                  element={<TradePage tradingStore={tradingStore} />}
                />
                <Route path="/privacy" element={<PolicyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route
                  path="/trade/create-post"
                  element={
                    <AccessGuard mustVerifiedPhone mustVerifiedAccount>
                      <CreatePost
                        tradingStore={tradingStore}
                        userStore={userStore}
                        commonStore={commonStore}
                      />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/trade/my-posts"
                  element={
                    <AccessGuard>
                      <MyPostsPage
                        tradingStore={tradingStore}
                        userStore={userStore}
                        commonStore={commonStore}
                      />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/trade/my-orders"
                  element={
                    <AccessGuard>
                      <MyOrderPage
                        userStore={userStore}
                        commonStore={commonStore}
                      />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/trade/orders/:orderId"
                  element={
                    <AccessGuard mustVerifiedAccount mustVerifiedPhone>
                      <ChatPage
                        userStore={userStore}
                        commonStore={commonStore}
                      />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/appeal/:appeal_id"
                  element={
                    <AccessGuard mustVerifiedAccount mustVerifiedPhone>
                      <AppealPage />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <AccessGuard>
                      <Profile
                        userStore={userStore}
                        commonStore={commonStore}
                      />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile/verification"
                  element={
                    <AccessGuard>
                      <Verification />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile/verify-phone-number"
                  element={
                    <AccessGuard>
                      <PhoneNumberVerifyPage />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile/payments"
                  element={
                    <AccessGuard>
                      <PaymentPage />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile/payments/create"
                  element={
                    <AccessGuard>
                      <PaymentCreateEditPage />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile/payments/:paymentId/edit"
                  element={
                    <AccessGuard>
                      <PaymentCreateEditPage />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/profile/mywallet"
                  element={
                    <AccessGuard>
                      <MyWallet />
                    </AccessGuard>
                  }
                />
                <Route
                  path="/verify-email/:qtoken"
                  element={<EmailVerifyPage />}
                />
                <Route path="/example-chat" element={<ChatPage />} />
              </Routes>
            </Box>
            <Footer userStore={userStore} commonStore={commonStore} />
          </Stack>
          <Web3Modal
            projectId={projectId}
            ethereumClient={ethereumClient}
            chainImages={{
              373737:
                "https://ipfs.io/ipfs/QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
              8794598:
                "https://ipfs.io/ipfs/QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
            }}
            tokenImages={{
              HAP: "https://ipfs.io/ipfs/QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
            }}
            themeVariables={{
              "--w3m-font-family": theme.typography.fontFamily,
              "--w3m-accent-color": "#0057d9",
              "--w3m-background-color": "#0057d9",
            }}
            defaultChain={IS_TESTNET ? chains[2] : chains[1]}
            themeMode="light"
            explorerExcludedWalletIds={"ALL"}
            explorerRecommendedWalletIds={[
              "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
            ]}
          />
        </Router>
        <Dialog open={commonStore.actionState != UI_ACTION_STATE.NONE}>
          <DialogContent sx={{ overflowY: "visible" }}>
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  {commonStore.actionState ==
                    UI_ACTION_STATE.WALLET_CONFIRMATION_PENDING && (
                    <>
                      <Typography variant="h6" sx={{ mr: 1 }}>
                        Please confirm on your wallet
                      </Typography>
                    </>
                  )}
                  {commonStore.actionState ==
                    UI_ACTION_STATE.TRANSACTION_PENDING && (
                    <Typography variant="h6" sx={{ mr: 1 }}>
                      Transaction confirmation pending
                    </Typography>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </Dialog>
      </MUIThemeProvider>
    );
  }),
);
export default App;
